module.exports = __webpack_public_path__ + "/bundle/asset/U1_01-7b37a1eda27238e3b79346a8bd679f9f.gif";